import { Resource } from "../../types";

export const BACKEND_PATH_FOR_RESOURCE: Record<Resource, string> = {
  [Resource.Account]: "accounts",
  [Resource.AccountOverageNotification]: "account_overage_notifications",
  [Resource.AccountRegion]: "account_regions",
  [Resource.AccountUserCount]: "analytics/account_user_counts",
  [Resource.ActiveUserCount]: "active_user_counts",
  [Resource.AdminRoleMembership]: "admin_role_memberships",
  [Resource.AdminUser]: "admin_users",
  [Resource.ApiKey]: "api_keys",
  [Resource.AuditLogConfigVariables]: "config_variable_audit_logs",
  [Resource.AuditLogProject]: "audit_logs/projects",
  [Resource.BoxToken]: "box_tokens",
  [Resource.CanceledEnterpriseOwner]: "canceled_enterprise_users",
  [Resource.CanceledInAppPurchaseUser]: "canceled_in_app_purchase_users",
  [Resource.CanceledStripeOwner]: "canceled_stripe_users",
  [Resource.Charge]: "charges",
  [Resource.Company]: "companies",
  [Resource.ConfigVariable]: "config_variables",
  [Resource.DemoProjectTemplate]: "demo_project_templates",
  [Resource.DemoProjectUser]: "demo_project_users",
  [Resource.DropboxToken]: "dropbox_tokens",
  [Resource.EnterprisePlan]: "enterprise_plans",
  [Resource.EnterprisePlanInvoice]: "enterprise_plan_invoices",
  [Resource.FeatureFlag]: "feature_flags",
  [Resource.InAppPurchase]: "in_app_purchases",
  [Resource.JobInfo]: "job_infos",
  [Resource.ManualWorker]: "manual_work_items",
  [Resource.MicrosoftToken]: "microsoft_tokens",
  [Resource.OtcMaintenanceWindow]: "otc_maintenance",
  [Resource.PayingEnterpriseOwner]: "paying_enterprise_users",
  [Resource.PayingInAppPurchaseUser]: "paying_in_app_purchase_users",
  [Resource.PayingStripeOwner]: "paying_stripe_users",
  [Resource.Project]: "projects",
  [Resource.ProjectsUser]: "projects_users",
  [Resource.SsoInfo]: "sso_infos",
  [Resource.StressTestingProject]: "stress_testing/generate_project",
  [Resource.StripeSubscription]: "stripe_subscriptions",
  [Resource.SyncError]: "sync_errors",
  [Resource.User]: "users",
};

export const getBackendPath = (resource: Resource): string =>
  BACKEND_PATH_FOR_RESOURCE[resource];
